import React from "react";
import { getResidentPassInformation } from "../../../utils/Parses";
import { CardItemAuthorization } from "../../../components/common/CardItemAuthorization";
import { useContext } from "react";
import UserContext from "../../../context/user-context";
import { AuthorizationType, GuestType } from "../../../store/types/userTypes";
import { useTranslation } from "../../../hooks/useTranslation";
import {
  markAuthorization,
  toggleAuthorization,
} from "../../../store/actions/userAction";
import { CardAuthorization } from "../CardAuthorization/CardAuthorization";
import { EntrantTabIndex } from "../../../utils/tabIndex";

export const CurrentAuthorization = () => {
  const { state, dispatch } = useContext(UserContext);
  const { t, BundleKey } = useTranslation();

  const handleCheckBoxChange = (
    value: boolean,
    id: string,
    guestType: GuestType
  ) => {
    dispatch(markAuthorization(id, value, AuthorizationType.current));
  };

  const handleToggleChange = (value: GuestType, id: string) => {
    dispatch(toggleAuthorization(id, value, AuthorizationType.current));
  };

  return (
    <>
      {state.authorizations?.length > 0 &&
      state.authorizations?.some(
        (item) => item.type === AuthorizationType.current
      ) ? (
        <CardAuthorization
          title={t(BundleKey.DETAIL_AUTHORIZATION_CURRENT_TITLE)}
          type={AuthorizationType.current}
        >
          {state.authorizations.map((pass, index) => {
            if (pass.type === AuthorizationType.current && !pass.hidden)
              return (
                <CardItemAuthorization
                  key={index}
                  id={pass.id}
                  tabIndex={EntrantTabIndex.currentAuthorizations}
                  checkValue={pass.mark}
                  checkHandle={(
                    value: boolean,
                    id: string,
                    guestType: GuestType
                  ) => handleCheckBoxChange(value, id, guestType)}
                  toggleTypeValue={pass.guestType}
                  toggleTypeHandle={(value: GuestType, id: string) =>
                    handleToggleChange(value, id)
                  }
                >
                  {getResidentPassInformation(
                    pass.authorization.host,
                    pass.authorization.beginDatetime,
                    pass.authorization.endDatetime,
                    pass.authorization
                  )}
                </CardItemAuthorization>
              );
          })}
        </CardAuthorization>
      ) : null}
    </>
  );
};
